export default __webpack_public_path__ + "static/media/itau.19b9270f.svg";